'@/pages/artwork/content-section/socials/artwork-thoughts/components/styles/ThoughtInput.css';
// src/shared-components/board-comments/CommentForm.jsx
import { useEffect, useRef,useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import UploadArrowUp from '@/shared-components/icons/components/actions/UploadArrowUp';

// reuse the ThoughtInput styles:
import '@/pages/artwork/content-section/socials/artwork-thoughts/components/styles/ThoughtInput.css';
import './CommentForm.css';

export default function CommentForm({
  resourceType,
  resourceId,
  parentId = null,
  isFirstComment = false,
  replyToUser,
  onNewComment
}) {
  const { state } = useStateHandler();
  const textarea   = useRef();
  const [text, setText]           = useState('');
  const [submitting, setSubmitting] = useState(false);

  // auto‐resize whenever text changes
  useEffect(() => {
    if (!textarea.current) return;
    textarea.current.rows = 1;
    const lh = parseInt(getComputedStyle(textarea.current).lineHeight);
    textarea.current.rows = Math.ceil(textarea.current.scrollHeight / lh);
  }, [text]);

  useEffect(() => {
    if (replyToUser) {
      textarea.current.value = `@${replyToUser} `;
      textarea.current.focus();
    } else {
      textarea.current.value = '';
    }
  }, [replyToUser]);

  const handleSubmit = async e => {
    e.preventDefault();
    const trimmed = text.trim();
    if (!trimmed) return;

    setSubmitting(true);
    try {
      await GalleryService.createComment(
        resourceType,
        resourceId,
        trimmed,
        parentId
      );
      setText('');
      onNewComment();
    } catch (err) {
      console.error('[CommentForm] post failed', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`board-comment-form artwork-view-thoughts__input-container${submitting ? ' read-only' : ''}`}
    >
      {/* avatar on the left, just like ThoughtInput */}
      <UserProfileImage
        typeOfProfile={state?.user_session?.user_type}
        image={state?.user_session?.user_image?.image_id}
        className="artwork-view-thoughts__profile_img"
      />

      <div className="artwork-view-thoughts__textarea-outter-container">
        <div className="artwork-view-thoughts__textarea-container">
          <textarea
            ref={textarea}
            rows={1}
            value={text}
            disabled={submitting}
            placeholder={parentId ? 'Write a reply…' : (isFirstComment ? 'Add first comment' : 'Write a comment…')}
            className="artwork-view-thoughts__textarea remove-scrollbar"
            onChange={e => setText(e.target.value)}
          />
        </div>
      </div>

      <button
        type="submit"
        className="artwork-view-thoughts__publish-thought"
        disabled={submitting || !text.trim()}
      >
        <div className="artwork-view-thoughts__publish-thought-circle">
          <UploadArrowUp/>
        </div>
      </button>
    </form>
  );
}
